<template>
	<div class="EditViewProduct">
		<!-- <el-button
			icon="el-icon-arrow-left"
			type="warning"
			style="width:auto;"
			size="mini"
			@click="$router.go(-1)"
		>
			Previous Page
		</el-button> -->
		<el-row :gutter="20">
			<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
				<div class="option">
					<p class="input-label">
						Select Vendor
					</p>
					<el-select
						v-model="vendor"
						style="width:100%"
						collapse-tags
						placeholder="Select Vendor"
						value-key="id"
						@change="getVendorDetails"
					>
						<el-option
							v-for="(vendor, vendorIndex) in vendors"
							:key="vendorIndex"
							:label="vendor.account_info.name"
							:value="vendor"
						/>
					</el-select>
				</div>
			</el-col>
			<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
				<div class="option">
					<p class="input-label" for="">
						Select Product
					</p>
					<!-- :disabled="editCatolog == false" -->
					<el-select
						v-model="product"
						style="width:100%"
						multiple
						filterable
						collapse-tags
						placeholder="Select"
					>
						<el-option
							v-for="(article, index) in articles"
							:key="index"
							:label="article.name"
							:value="article.id"
						/>
					</el-select>
				</div>
			</el-col>
			<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
				<div class="option">
					<p class="input-label" for="">
						Vendor Status
					</p>
					<el-select
						v-model="vendorStatus"
						style="width:100%"
						:disabled="!vendor.id"
						collapse-tags
						placeholder="Select status"
						@change="showVendorStatusButton = true"
					>
						<el-option label="Active" value="active" />
						<el-option label="Inactive" value="inactive" />
						<el-option label="Delete" value="delete" />
					</el-select>
				</div>
			</el-col>
			<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
				<div class="option">
					<BaseButton
						v-if="showVendorStatusButton"
						type="submit"
						buttonclass="btn p-2.5 text-sm"
						@click="saveVendorStatus(vendorStatus)"
					>
						Save Vendor Status
					</BaseButton>
				</div>
			</el-col>
		</el-row>
		<el-row :gutter="20">
			<el-col :xs="24" :sm="12" :md="4" :lg="4" :xl="4">
				<div class="option">
					<BaseButton
						type="submit"
						buttonclass="btn p-2.5 text-xs"
						@click="showSupplierDetailsFn"
					>
						Supplier Details
					</BaseButton>
				</div>
			</el-col>
			<el-col :xs="24" :sm="12" :md="4" :lg="4" :xl="4">
				<div class="option">
					<BaseButton
						type="submit"
						buttonclass="btn p-2.5 text-xs"
						@click="editProduct"
					>
						Edit Catolog
					</BaseButton>
				</div>
			</el-col>
			<el-col :xs="24" :sm="12" :md="4" :lg="4" :xl="4">
				<div class="option">
					<BaseButton
						type="submit"
						buttonclass="btn p-2.5 text-xs"
						@click="addProducts"
					>
						Add Products
					</BaseButton>
				</div>
			</el-col>
			<el-col :xs="24" :sm="12" :md="4" :lg="4" :xl="4">
				<div class="option">
					<BaseButton
						type="submit"
						buttonclass="btn p-2.5 text-xs"
						@click="displayStores"
					>
						View Store List
					</BaseButton>
				</div>
			</el-col>
		</el-row>
		<div v-if="showSupplierDetails == true">
			<div>
				<p style="border-bottom: 1px solid #ccc;margin-bottom: 5px;">
					Supplier
				</p>
				<el-row :gutter="20">
					<el-col :xl="8" :lg="8" :md="8" :sm="12" :xs="24">
						<p class="input-label">Supplier Name</p>
						<div>
							<el-select
								v-model="supplierDetails.id"
								class="custom-input"
								style="width: 100%;"
								collapse-tags
								placeholder="Select"
								name="suppliersName"
								@change="getSupplierDetails"
							>
								<el-option
									v-for="(supplier, supplierIndex) in suppliers"
									:key="supplierIndex"
									:label="supplier.name"
									:value="supplier.id"
								/>
							</el-select>
							<span
								:v-show="errors.has('suppliersName')"
								class="text-red-dark text-xs"
							>
								{{ errors.first("suppliersName") }}
							</span>
						</div>
					</el-col>
					<el-col :xl="8" :lg="8" :md="8" :sm="12" :xs="24">
						<p class="input-label">Supplier Id</p>
						<BaseInput
							v-model="supplierDetails.id"
							class="custom-input"
							placeholder="Supplier Id"
						/>
					</el-col>
					<el-col :xl="8" :lg="8" :md="8" :sm="12" :xs="24">
						<p class="input-label">Minimum Order</p>
						<BaseInput
							v-model="vendorDetails.minimum_order_amount"
							v-validate="'numeric'"
							class="custom-input"
							placeholder="Minimum Order"
							name="minimumOrder"
						/>
						<span
							:v-show="errors.has('minimumOrder')"
							class="text-red-dark text-xs"
						>
							{{ errors.first("minimumOrder") }}
						</span>
					</el-col>
				</el-row>
			</div>
			<div>
				<p style="border-bottom: 1px solid #ccc;margin-bottom: 5px;">
					Contact
				</p>
				<el-row :gutter="20">
					<el-col :xl="8" :lg="8" :md="8" :sm="12" :xs="24">
						<p class="input-label">Name</p>
						<BaseInput
							v-model="supplierDetails.name"
							class="custom-input"
							placeholder="First Name"
						/>
					</el-col>
					<el-col :xl="8" :lg="8" :md="8" :sm="12" :xs="24">
						<p class="input-label">Email</p>
						<BaseInput
							v-model="supplierDetails.email"
							class="custom-input"
							placeholder="Email"
						/>
					</el-col>
					<el-col :xl="8" :lg="8" :md="8" :sm="12" :xs="24">
						<p class="input-label">Alternate Email</p>
						<BaseInput class="custom-input" placeholder="Alternate Email" />
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :xl="8" :lg="8" :md="8" :sm="12" :xs="24">
						<p class="input-label">Office Phone</p>
						<BaseInput class="custom-input" placeholder="Office Phone" />
					</el-col>
					<el-col :xl="8" :lg="8" :md="8" :sm="12" :xs="24">
						<p class="input-label">Mobile</p>
						<BaseInput
							v-model="supplierDetails.phone"
							class="custom-input"
							placeholder="Mobile"
						/>
					</el-col>
					<el-col :xl="8" :lg="8" :md="8" :sm="12" :xs="24">
						<p class="input-label">Order Created By:</p>
						<div>
							<el-select
								v-model="vendorDetails.order_created_by"
								v-validate="'required'"
								class="custom-input"
								style="width: 100%;"
								collapse-tags
								placeholder="Select"
								name="Order Created By"
							>
								<el-option label="Store" value="store" />
								<el-option label="Head Office" value="head_office" />
							</el-select>
							<span
								:v-show="errors.has('Order Created By')"
								class="text-red-dark text-xs"
							>
								{{ errors.first("Order Created By") }}
							</span>
						</div>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="top-margin">
					<el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="24">
						<p class="input-label">Approval Required?</p>
						<div class="custom-input">
							<el-checkbox
								v-model="vendorDetails.approval_required"
								style="display: block;margin-bottom: 20px;height: 40px;margin-top: 5px;width: 100%;"
								:border="true"
								size="medium"
								true-label="true"
								false-label="false"
							>
								<p v-if="approvalRequired == 'true'">
									&nbsp;&nbsp;Yes
								</p>
								<p v-if="approvalRequired == 'false'">
									&nbsp;&nbsp;&nbsp;No
								</p>
							</el-checkbox>
						</div>
					</el-col>
					<el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="24">
						<p class="input-label">Approve By</p>
						<div>
							<el-select
								v-model="vendorDetails.approved_by"
								v-validate="approvalRequired === 'true' ? 'required' : ''"
								style="width: 100%;"
								collapse-tags
								placeholder="Select"
								class="custom-input"
								name="Approved By"
							>
								<el-option
									v-for="(user, userIndex) in users"
									:key="userIndex"
									:label="user.first_name + ' ' + user.last_name"
									:value="user.id"
								/>
							</el-select>
							<span
								:v-show="errors.has('Approved By')"
								class="text-red-dark text-xs"
							>
								{{ errors.first("Approved By") }}
							</span>
						</div>
					</el-col>
					<el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="24">
						<p class="input-label">Approve Order By(Time)</p>
						<div class="custom-input">
							<el-time-picker
								v-model="vendorDetails.approve_before"
								v-validate="approvalRequired === 'true' ? 'required' : ''"
								placeholder="Select time"
								style="width: 100%"
								value-format="HH:mm:ss"
								format="HH:mm:ss"
								name="Approve Order By"
							>
							</el-time-picker>
							<span
								:v-show="errors.has('Approve Order By')"
								class="text-red-dark text-xs"
							>
								{{ errors.first("Approve Order By") }}
							</span>
						</div>
					</el-col>
					<el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="24">
						<p class="input-label">Auto Approval</p>
						<el-checkbox
							v-model="vendorDetails.auto_approval"
							style="display: block;margin-bottom: 20px;height: 40px;margin-top: 5px;width: 100%;"
							:border="true"
							size="medium"
							true-label="true"
							false-label="false"
						>
							<p v-if="autoApproval == 'true'">
								&nbsp;&nbsp;Yes
							</p>
							<p v-if="autoApproval == 'false'">
								&nbsp;&nbsp;&nbsp;No
							</p>
						</el-checkbox>
					</el-col>
				</el-row>
			</div>
		</div>
		<div v-if="showSupplierDetails == true">
			<BaseScheduleOrderTable :schedule-order="vendorDetails.schedule"
				><template slot="saveButton">
					<div>
						<BaseButton
							class="mt-4"
							buttonclass="btn py-1.5 px-4 text-xs"
							@click="editSupplierDetails"
						>
							Save
						</BaseButton>
					</div>
				</template></BaseScheduleOrderTable
			>
		</div>
		<div v-else-if="editCatolog && vendorSupplies.length">
			<BaseProductsTable
				:is-edit="editCatolog"
				:products="vendorSupplies"
				:is-add-product-button="showAddProducts"
				:show-external-supplier-fields="
					vendorDetails.type === 'internal' ? false : true
				"
				:show-table="true"
				@editArticle="editArticle"
				@deleteArticle="deleteArticle"
			></BaseProductsTable>
			<div class="text-right">
				<el-pagination
					background
					:current-page.sync="pageInfo.currentPage"
					:page-sizes="[5, 10, 15]"
					:page-size.sync="pageInfo.pageSize"
					layout="sizes, prev, pager, next"
					:total="pageInfo.totalCount"
					@size-change="handlePageInfoChange"
					@current-change="handlePageInfoChange"
				/>
			</div>
		</div>
		<div v-else-if="showAddProducts">
			<BaseProductsTable
				:products="vendorSupplies"
				:show-external-supplier-fields="
					vendorDetails.type === 'internal' ? false : true
				"
				:is-add-product-button="showAddProducts"
				:show-table="true"
				><template slot="saveButton">
					<div>
						<BaseButton
							class="mt-4"
							buttonclass="btn py-1.5 px-4 text-xs"
							@click="addVendorSupplies"
						>
							Save
						</BaseButton>
					</div>
				</template></BaseProductsTable
			>
		</div>
		<el-dialog :visible.sync="dialogVisible" top="0" width="40%">
			<ViewStoreList
				:stores="stores"
				:locations="vendorDetails.supplied_stores"
				@editSuppliedStores="editSuppliedStores"
			/>
		</el-dialog>
		<el-dialog title="Alert !" :visible.sync="isShowPopUp" width="40%">
			<span>Unsaved Data will be lost.</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="isShowPopUp = false">Cancel</el-button>
				<el-button type="warning" @click="changeUrl()">Confirm</el-button>
			</span>
		</el-dialog>
		<!-- <router-view /> -->
	</div>
</template>

<script>
import ViewStoreList from "./viewStoreList/ViewStoreList.vue";
import InventoryService from "../../../../../services/inventoryService";
import CommonService from "../../../../../services/commonService";
import UserAccountsService from "../../../../../services/userAccountsService";
import { SuppliersMixin } from "../../../../../../mixins/suppliers.mixin";
import { CommonMixin } from "../../../../../../mixins/common.mixin";
import { resolve } from "q";
import NProgress from "nprogress";
export default {
	name: "EditViewProduct",
	components: {
		ViewStoreList
	},
	mixins: [SuppliersMixin, CommonMixin],
	data() {
		return {
			orderCreatedBy: "",
			approvalRequired: "",
			approvedBy: "",
			approveOrderTime: "",
			autoApproval: "",
			isShowPopUp: false,
			vendor: {},
			stores: [],
			articles: [],
			vendorDetails: {},
			supplierDetails: {},
			vendorSupplies: [],
			product: "",
			vendorStatus: "",

			value: "value",
			editCatolog: false,
			showSupplierDetails: true,
			showVendorStatusButton: false,
			showEditCatolog: false,
			showAddProducts: false,
			dialogVisible: false,
			pageInfo: {
				currentPage: 1,
				totalCount: 0,
				pageSize: 10,
				search: ""
			}
		};
	},
	created() {
		this.getVendors();
		this.getArticles({ get_all: true });
		this.getUsers({
			get_all: true,
			fields: ["id", "first_name", "last_name"]
		});
	},
	methods: {
		paginate() {
			return pageInfo => {
				this.getVendorDetails(this.vendor);
			};
		},
		async getArticles(args) {
			try {
				this.articles = await InventoryService.getArticles(args).then(
					response => resolve(JSON.parse(response.data))
				);
			} catch (err) {
				console.log(err);
			}
		},
		async saveVendorStatus(status) {
			if (status === "active" || status === "inactive") {
				this.vendorDetails.active = status === "active" ? true : false;
				try {
					var editStatus = await this.editVendor().then(response =>
						resolve(response)
					);
				} catch (err) {
					console.log(err);
					this.$notify.error({
						title: "Fail",
						message: "Something Went Wrong"
					});
				}
				if (editStatus) {
					this.$notify.success({
						title: "Success",
						message: "Edited Successfully"
					});
				}
			}

			if (status === "delete") {
				try {
					var deleteStatus = InventoryService.deleteVendor({
						vendorId: this.vendorDetails.id
					}).then(response => resolve(response.status));
					if (deleteStatus === 204) {
						if (editStatus === 200) {
							this.$notify.success({
								title: "Success",
								message: "Deleted Successfully"
							});
						}
					}
				} catch (err) {
					console.log(err);
					this.$notify.error({
						title: "Fail",
						message: "Something Went Wrong"
					});
				}
			}
		},
		async editSuppliedStores(locations) {
			this.vendorDetails.supplied_stores = locations;
			try {
				var editStatus = await this.editVendor().then(response =>
					resolve(response)
				);
			} catch (err) {
				console.log(err);
				this.$notify.error({
					title: "Fail",
					message: "Something Went Wrong"
				});
			}
			if (editStatus === 200) {
				this.dialogVisible = false;
				this.$notify.success({
					title: "Success",
					message: "Edited Successfully"
				});
			}
			// console.log("locations in viewStoresList", locations);
		},
		async addVendorSupplies() {
			try {
				await this.createVendorSupplies({
					vendorId: this.vendorDetails.id,
					params: this.vendorSupplies
						.filter(product => product.itemName !== "")
						.map(product => {
							if (this.vendorDetails.type === "external") {
								return {
									article: product.itemName,
									order_unit: product.orderUnit || null,
									order_unit_conversion: product.contains || null,
									weightable: product.weightable,
									minimum_order: Number(product.minimumOrder) || null,
									deposit: Number(product.deposit) || null,
									tax: Number(product.tax) || null,
									order_unit_cost: Number(product.orderUnitCost) || null,
									base_unit_cost: Number(product.baseUnitCost) || null
								};
							} else {
								return {
									article: product.itemName,
									order_unit: product.orderUnit || null,
									order_unit_conversion: product.contains || null
								};
							}
						})
				}).then(response => {
					console.log("response", response);

					if (response && response.status === 201) {
						this.$notify.success({
							title: "Success",
							message: "Added Successfully"
						});
					}
				});
			} catch (err) {
				console.log(err.response.data);
				// if (err.response.status === 400) {
				this.$notify.error({
					title: "Fail",
					message: JSON.parse(err.response.data).msg || "Something Went Wrong",
					duration: 0
				});
				// } else {
				// 	this.$notify.error({
				// 		title: "Fail",
				// 		message: "Something Went Wrong"
				// 	});
				// }
				NProgress.done();
			}
		},
		async editArticle(index) {
			console.log("index of article", this.vendorSupplies[index]);
			try {
				var editArticleStatus = await InventoryService.editVendorSupplies({
					vendorId: this.vendorDetails.id,
					articleId: this.vendorSupplies[index].articleId,
					params: {
						article: this.vendorSupplies[index].itemName,
						order_unit: this.vendorSupplies[index].orderUnit,
						order_unit_conversion: this.vendorSupplies[index].contains,
						weightable: this.vendorSupplies[index].weightable,
						minimum_order: this.vendorSupplies[index].minimumOrder,
						deposit: this.vendorSupplies[index].deposit,
						tax: this.vendorSupplies[index].tax,
						order_unit_cost: this.vendorSupplies[index].orderUnitCost,
						base_unit_cost: this.vendorSupplies[index].baseUnitCost
					}
				}).then(response => resolve(response.status));
			} catch (err) {
				console.log(err);
				this.$notify.error({
					title: "Fail",
					message: "Something Went Wrong"
				});
			}
			if (editArticleStatus === 200) {
				this.$notify.success({
					title: "Success",
					message: "Edited Successfully"
				});
			}
		},
		async deleteArticle(index) {
			console.log("index of article", this.vendorSupplies[index]);
			try {
				var deleteArticleStatus = await InventoryService.deleteVendorSupplies({
					vendorId: this.vendorDetails.id,
					articleId: this.vendorSupplies[index].articleId
				}).then(response => resolve(response.status));
			} catch (err) {
				console.log(err);
				this.$notify.error({
					title: "Fail",
					message: "Something Went Wrong"
				});
			}
			if (deleteArticleStatus === 204 || deleteArticleStatus === 200) {
				this.vendorSupplies.splice(index, 1);
				this.$notify.success({
					title: "Success",
					message: "deleted Successfully"
				});
			}
		},
		async editSupplierDetails() {
			try {
				var editAccountStatus = await UserAccountsService.editOutlet(
					this.vendorDetails.account,
					{
						name: this.supplierDetails.name,
						phone: this.supplierDetails.phone,
						email: this.supplierDetails.email,
						type: this.supplierDetails.type,
						store_type: this.supplierDetails.store_type,
						address_line1: this.supplierDetails.address_line1,
						address_line2: this.supplierDetails.address_line2,
						pincode: this.supplierDetails.pincode,
						latitude: this.supplierDetails.latitude,
						longitude: this.supplierDetails.longitude,
						country: this.supplierDetails.country,
						region: this.supplierDetails.region,
						subregion: this.supplierDetails.subregion,
						city: this.supplierDetails.city,
						approval_required: this.supplierDetails.approval_required,
						approve_before: this.supplierDetails.approve_before,
						approved_by: this.supplierDetails.approved_by,
						auto_approval: this.supplierDetails.auto_approval
					}
				).then(response => resolve(response.status));
				if (editAccountStatus === 200) {
					var editStatus = await this.editVendor().then(response =>
						resolve(response)
					);
					// console.log("editSupplierStatus", editSupplierStatus);
				}
			} catch (err) {
				console.log(err);
				this.$notify.error({
					title: "Fail",
					message: "Something Went Wrong"
				});
			}
			if (editStatus === 200) {
				this.$notify.success({
					title: "Success",
					message: "Supplier Details Edited"
				});
			}
		},
		async editVendor() {
			try {
				var editSupplierStatus = await InventoryService.editVendor({
					vendorId: this.vendorDetails.id,
					params: {
						account: this.vendorDetails.account,
						active: this.vendorDetails.active,
						// type: this.vendorDetails.type,
						// order_created_by: this.orderCreatedBy,
						// approval_required: this.approvalRequired === "true" ? true : false,
						// approved_by: this.approvedBy || null,
						// approve_before: this.approveOrderTime || null,
						// auto_approval: this.autoApproval === "true" ? true : false,
						order_created_by: this.vendorDetails.order_created_by,
						approval_required: this.vendorDetails.approval_required,
						approved_by: this.vendorDetails.approved_by,
						approve_before: this.vendorDetails.approve_before,
						auto_approval: this.vendorDetails.auto_approval,
						schedule:
							this.vendorDetails.schedule
								.filter(schedule => schedule.day !== "")
								.reduce((acc, v) => {
									acc[v["day"]] = v["untill"];
									return acc;
								}, {}) || {},
						supplied_stores: this.vendorDetails.supplied_stores,
						// is_default: this.vendorDetails.is_default,
						order_anytime: this.vendorDetails.order_anytime,
						eta: Number(this.vendorDetails.eta),
						minimum_order_amount: Number(
							this.vendorDetails.minimum_order_amount
						)
					}
				}).then(response => resolve(response.status));
			} catch (err) {
				console.log(err);
				throw err;
			}
			return editSupplierStatus;
		},
		async getVendorDetails(vendor) {
			console.log("vendor", vendor);
			try {
				this.vendorDetails = await InventoryService.getVendor({
					vendorId: vendor.id
				}).then(response => {
					const vendorDetails = JSON.parse(response.data);
					vendorDetails.schedule =
						Object.entries(vendorDetails.schedule).length === 0 &&
						vendorDetails.schedule.constructor === Object
							? []
							: Object.entries(vendorDetails.schedule).map(schedule => {
									return {
										day: Number(schedule[0]),
										untill: schedule[1]
									};
							  });
					return resolve(vendorDetails);
				});
				this.getSuppliers({
					//type should not be a store user for internal supplier
					get_all: true,
					type: this.vendor.type === "internal" ? "" : "vendor",
					not: this.vendor.type === "internal" ? "store" : ""
				});
				await this.getSupplierDetails(this.vendorDetails.account);
				if (this.editCatolog) {
					this.vendorSupplies = [];
					var vendorSupplies = await this.getVendorSupplies(vendor.id);
					this.vendorSupplies = vendorSupplies;
					if (!this.vendorSupplies.length) {
						this.$notify({
							title: "Warning",
							message: "No supplies",
							type: "warning"
						});
					}
					console.log("vendor supplies", vendorSupplies);
				}
			} catch (err) {
				console.log(err);
			}
		},
		async getSupplierDetails(id) {
			try {
				this.supplierDetails = await UserAccountsService.getOutlet(id).then(
					response => resolve(JSON.parse(response.data))
				);
				console.log("this.supplierDetails", this.supplierDetails);
			} catch (err) {
				console.log(err);
			}
		},
		async getVendorSupplies(vendorId) {
			try {
				var vendorSupplies = await InventoryService.getVendorSupplies({
					vendorId: vendorId,
					pageInfo: this.pageInfo
				}).then(response => {
					const data = JSON.parse(response.data).results;
					this.pageInfo.totalCount = JSON.parse(response.data).count;
					var proudctId = 1;
					console.log("data in vendorSupplies", data);

					const products = data.map(product => {
						proudctId += 1;
						return {
							articleId: product.id,
							itemId: product.item.id,
							itemName: product.item.id,
							itemCode: product.item.code,
							itemType: product.item.type,
							orderUnit: product.order_unit,
							contains: product.order_unit_conversion,
							baseUnit: "",
							orderUnitCost: product.order_unit_cost,
							baseUnitCost: "",
							weightable: product.weightable,
							minimumOrder: product.minimum_order,
							deposit: product.deposit,
							tax: product.tax,
							id: proudctId
						};
					});
					return resolve(products);
				});
			} catch (err) {
				console.log(err);
			}
			console.log("this.vendorSupplies", this.vendorSupplies);
			return vendorSupplies;
		},
		async displayStores() {
			if (this.vendor.hasOwnProperty("id") && !this.vendor.id !== "") {
				this.stores = await this.getAllOutlets({
					get_all: true,
					fields: ["id", "name"]
				}).then(outlets => {
					this.editCatolog = false;
					this.showSupplierDetails = false;
					this.showAddProducts = false;
					this.dialogVisible = true;
					return resolve(outlets);
				});
			} else {
				this.$notify.error({
					title: "Fail",
					message: "Please Select Vendor"
				});
			}
			// this.getUsers =
		},
		async editProduct() {
			if (this.vendor.hasOwnProperty("id") && !this.vendor.id !== "") {
				var vendorSupplies = await this.getVendorSupplies(this.vendor.id);
				console.log("vendor supplies", vendorSupplies);
				this.vendorSupplies = vendorSupplies;
				if (!this.vendorSupplies.length) {
					this.$notify({
						title: "Warning",
						message: "No supplies",
						type: "warning"
					});
				} else {
					this.editCatolog = true;
					this.showSupplierDetails = false;
					this.showAddProducts = false;
				}
			} else {
				this.$notify.error({
					title: "Fail",
					message: "Please Select Vendor"
				});
			}
		},
		showSupplierDetailsFn() {
			this.editCatolog = false;
			this.showAddProducts = false;
			this.showSupplierDetails = true;
		},
		addProducts() {
			if (this.vendor.hasOwnProperty("id") && !this.vendor.id !== "") {
				this.editCatolog = false;
				this.showSupplierDetails = false;
				this.showAddProducts = true;
				this.vendorSupplies = [];
			} else {
				this.$notify.error({
					title: "Fail",
					message: "Please Select Vendor"
				});
			}
		},
		changeUrl() {
			this.isRouteChanged = true;
			this.isShowPopUp = false;
			this.$router.push({ path: this.path }).catch(()=>{})
			// this.editProduct();

		}
	},
	beforeRouteLeave(to, from, next) {
		this.isShowPopUp = true;
		this.path = to.path;
		if (this.isRouteChanged) {
			next();
		} else {
			next(false);
		}
	}
};
</script>

<style lang="scss" scoped>
@import "./EditViewProduct.scss";
</style>
<style>
.el-select__input:focus {
	border: none;
}
</style>
